import { render, staticRenderFns } from "./SpecificSchool.vue?vue&type=template&id=46fe6e58&scoped=true&"
import script from "./SpecificSchool.vue?vue&type=script&lang=ts&"
export * from "./SpecificSchool.vue?vue&type=script&lang=ts&"
import style0 from "./SpecificSchool.vue?vue&type=style&index=0&id=46fe6e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe6e58",
  null
  
)

export default component.exports